#import "../fragments/notification-fragment.graphql"

mutation MarkNotificationRead($id: ID!) {
    notificationMarkRead(input: {id: $id}) {
        notification {
            ...NotificationFragment
        }
    }
}
